module.exports = __webpack_public_path__ + "static/img/amd10.f2dced8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/amd10.png
// module id = H2cv
// module chunks = 1